/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getLocationPermission} from '../api'

 export const useQueryGetLocationPermission = createReactQueryHook('getLocationPermission', getLocationPermission)
